<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/dIz4fh/tc-custom/9780823268764.jpg?1702540038964" alt="This image is the cover for the book Too Great a Burden to Bear, Reconstructing America"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Too Great a Burden to Bear, Reconstructing America
      </h1>
      <p class="bookDescription body article font2">
        <b>This Reconstruction Era historical study of the Freedman’s Bureau in Texas offers a personal view of the lives, struggles and misconceptions of its agents.</b><br/><br/>Formed at the close of the Civil War to provide assistance to formerly enslaved people, the Freedmen’s Bureau became the epicenter of the debate about Reconstruction. Though its agents in Texas were vitally important, historians have only recently begun to focus on their operations. Specifically addressing the historiographical debates concerning the character of the Bureau and its sub-assistant commissioners (SACs), <i>Too Great a Burden to Bear</i> sheds new light on the work and reputation of these agents.<br/><br/>Focusing on the agents on a personal level, author Christopher B. Bean reveals the type of man Bureau officials believed qualified to oversee the Freedpeople’s transition to freedom. This work shows that each agent, moved by his sense of fairness and ideas of citizenship, gender, and labor, represented the agency’s policy in his subdistrict. These men further ensured the Freedpeople’s right to an education and right of mobility, rights fiercely contested by many in the South.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Christopher B. Bean
      </h2>
      
      <p class="authorDescription body article">Christopher B. Bean is Assistant Professor of History and Native American Studies at East Central University, Oklahoma.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Fordham University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f4a41baa